// src/components/ClientWrapper.tsx
"use client";

import React from "react";
import TranslationsClientProvider from "@/components/TranslationsClientProvider";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { Language } from "@/translations/supportedLanguages";

interface ClientWrapperProps {
  children: React.ReactNode;
  initialLanguage: Language;
  messages: Record<string, string>;

  // Currency context:
  initialCurrencyCode: string;
  initialCurrencySymbol: string;
  initialExchangeRate: number;
  initialCountryIso: string;
}

const ClientWrapper: React.FC<ClientWrapperProps> = ({
  children,
  initialLanguage,
  messages,
  initialCurrencyCode,
  initialCurrencySymbol,
  initialExchangeRate,
  initialCountryIso,
}) => (
  <CurrencyProvider
    initialCurrencyCode={initialCurrencyCode}
    initialCurrencySymbol={initialCurrencySymbol}
    initialExchangeRate={initialExchangeRate}
    initialCountryIso={initialCountryIso}
  >
    <TranslationsClientProvider
      messages={messages}
      initialLanguage={initialLanguage}
    >
      {children}
    </TranslationsClientProvider>
  </CurrencyProvider>
);

export default React.memo(ClientWrapper);
